import { createSlice } from "@reduxjs/toolkit";
import { loadCrmNotifications } from "./crmNotificationThunk";

const crmNotificationSlice = createSlice({
  name: "crmNotifications",
  initialState: {
    data: {},
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadCrmNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadCrmNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(loadCrmNotifications.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default crmNotificationSlice.reducer;